// Generated by Melange

import * as JitsuReact from "@jitsu/jitsu-react";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Link from "./Link.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(route) {
  return function (activeRoute) {
    return function (currentRoute) {
      return function (isActiveRoute) {
        return function (className) {
          return function (activeClassName) {
            return function (eventNameOpt) {
              const eventName = eventNameOpt !== undefined ? eventNameOpt : "";
              return function (children) {
                return function (onCloseOpt) {
                  const onClose = onCloseOpt !== undefined ? onCloseOpt : (function (param) {
                        
                      });
                  return function (bar) {
                    return function (setBar) {
                      return function (onMouseEnterOpt) {
                        const onMouseEnter = onMouseEnterOpt !== undefined ? onMouseEnterOpt : (function (param) {
                              
                            });
                        return function (onMouseLeaveOpt) {
                          const onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : (function (param) {
                                
                              });
                          const jitsu = JitsuReact.useJitsu();
                          const activeRoute$1 = Belt__Belt_Option.getWithDefault(activeRoute, route);
                          const currentRoute$1 = Belt__Belt_Option.getWithDefault(currentRoute, /* OrgChoose */0);
                          const funActiveRoute = Belt__Belt_Option.getWithDefault(isActiveRoute, (function (current) {
                                  return Caml_obj.caml_equal(activeRoute$1, current);
                                }));
                          const trackEvent = function (param) {
                            if (eventName === "") {
                              return ;
                            } else {
                              return Curry._1(jitsu.analytics.track, eventName);
                            }
                          };
                          const className$1 = Cn.fromList({
                                hd: Cn.on(Cn.take(className), !Curry._1(funActiveRoute, currentRoute$1)),
                                tl: {
                                  hd: Cn.on(Cn.take(activeClassName), Curry._1(funActiveRoute, currentRoute$1)),
                                  tl: /* [] */0
                                }
                              });
                          return JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                      route: route,
                                      className: className$1,
                                      onLinkClicked: (function (param) {
                                          trackEvent(undefined);
                                          Curry._1(onClose, undefined);
                                          Curry._1(setBar, (function (param) {
                                                  return bar;
                                                }));
                                        }),
                                      children: children,
                                      onMouseEnter: onMouseEnter,
                                      onMouseLeave: onMouseLeave
                                    });
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

function NavLink(Props) {
  return Curry.app(make(Props.route)(Props.activeRoute), [
              Props.currentRoute,
              Props.isActiveRoute,
              Props.className,
              Props.activeClassName,
              Props.eventName,
              Props.children,
              Props.onClose,
              Props.bar,
              Props.setBar,
              Props.onMouseEnter,
              Props.onMouseLeave
            ]);
}

const make$1 = NavLink;

export {
  make$1 as make,
}
/* @jitsu/jitsu-react Not a pure module */
